import { SubmenuButtonProps } from "@/components/player/layouts/shared/menus/menu-types";
import { Menu } from "@vidstack/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@vidstack/react/icons";
export function SubmenuButton({
  label,
  hint,
  icon: Icon,
  disabled
}: SubmenuButtonProps) {
  return <Menu.Button className="vds-menu-item" disabled={disabled} data-sentry-element="unknown" data-sentry-component="SubmenuButton" data-sentry-source-file="submenu-button.tsx">
            <ChevronLeftIcon className="vds-menu-close-icon" data-sentry-element="ChevronLeftIcon" data-sentry-source-file="submenu-button.tsx" />
            <Icon className="vds-icon" data-sentry-element="Icon" data-sentry-source-file="submenu-button.tsx" />
            <span className="vds-menu-item-label">{label}</span>
            <span className="vds-menu-item-hint">{hint}</span>
            <ChevronRightIcon className="vds-menu-open-icon" data-sentry-element="ChevronRightIcon" data-sentry-source-file="submenu-button.tsx" />
        </Menu.Button>;
}